import React from "react";



const Social = () => {
return(
    
<>
<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">SOCIAL MEDIA MARKETING</div>
<h3>Best social media marketing agency in Mumbai<br/>
<span>You have found for yourself the best social media marketing agency in Mumbai, ShellCode Solutions. Needless to say, now you do not have to pick your head about Social Media Marketing techniques to improve your presence in the digital sphere. ShellCode Solutions will do that for you. Our analysts and planners will create a Marketing plan specifically for your brand and get unbelievable results!
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>A never-used-before social media marketing strategy<br/>
        <span>
        Yes, you heard it right! Our Social Media Marketing strategy stands on innovation as well as experience. We give you exactly what you want by analyzing your competition and target base and creating special plans that work on getting more leads and increasing your conversion rate. Our meticulous team is there to back you up in your Social Media ventures!
        </span>
    </h3>
    <h3>Years of experience + unique designs<br/>
        <span>
        ShellCode Solutions, the best Social Media Marketing Agency in Mumbai, comes up with unique designs and concepts for your audience so that your users remain hooked. We utilize new and creative graphics and campaigns that will stand out in the market. Our strategies make you claim superiority over your competitors and make more leads flock to your platform.
        </span>
    </h3>
    <h3>We utilize paid advertisements efficiently<br/>
        <span>
        Organic techniques are important for any Social Media Marketing strategy. But we also focus on using paid advertisements for your brand's awareness. We are aware of the secrets of algorithms. You do not have to worry about gaining recognition on social media platforms that look like a puzzle at first sight. We will make everything easy, breaking down our process into small and efficient tasks and getting big results.
        Release Planning and Monitoring: We plan, we deliver. We monitor the development process throughout and ensure that you get everything on time!<br/>
        </span>
    </h3>
    <h3>We'll launch your brand<br/>
        <span>
        We understand that Social Media might spell R-A-C-E to some and keep you in the lead of that race. If you are a new and thriving brand, we work on launching your brand in the market. We help customers understand what you are offering, making our point come across via multiple campaigns that attract and engage. We launch teasers before launching your brand so that they know someone's coming to rule the digital world.</span>
    </h3>
    <h3>Available 24x7<br/>
        <span>
        We are always available. There is no particular time to avail of our services. We deliver as and when you need. Our analysts and strategists work day and night on your dream and make it theirs. We monitor the efficiency of campaigns 24x7 and are always ready for improvement.</span>
    </h3>
    <h3>Here's why we are the best!<br/>
        <span>
        Thorough research: We do not shy away from researching extensively about your niche, industry, competitors, and consumer base to make our social media marketing plans 100% effective.<br/>
Your vision is important: Your vision for your brand is as important as ours. We put your needs on top of our priority list and design a plan specifically for you.<br/>
Innovative plans: Our social media marketing strategies stand out. We guarantee innovative techniques that make people aware of your brand and turn them into long-lasting clients.<br/>
Huge ROI: The return that you get on your investment is unbelievably great. Do not believe us? See for yourself. <br/>
Further optimization: We constantly monitor the social media marketing strategies that we have employed and work on the scope for further improvement and optimize our plan accordingly.<br/>
Your growth, our priority: Your growth is our priority. We thrive on mutual growth through trust and reliability. <br/>
        </span></h3>
        <h3>Social Media Marketing for all niches<br/>
        <span>
        We build a brand for tomorrow using innovative Social Media Marketing techniques. Market analysis is an essential part of our strategy. We constantly monitor your niche and industry and analyze and determine what your consumers want and need. 
        </span></h3>

        <h3>Our clients across the globe<br/>
            <span>We've been a part of the branding process for clients across the globe. We have catered to various brands in diverse fields of services and made them humongous. We will not disappoint. So why wait? Pick us already!
            </span></h3>
</div>
    </>
)
}

export default Social;
